import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import withEnterpriseLayout from 'src/components/AppRoutes/Enterprise/withEnterpriseLayout';
import { CreateReportsPage } from 'src/components/enterprise/features/Reporting/CreateReportsPage/CreateReportsPage';
import { ManageReportsPage } from 'src/components/enterprise/features/Reporting/ManageReportsPage/ManageReportsPage';
import { ReportingPaths } from 'src/components/AppRoutes/Enterprise/ReportingPaths';

export const ReportingRoutes = (): JSX.Element => {
  const CreateReportsPageLayout = withEnterpriseLayout(CreateReportsPage);
  const ManageReportsPageLayout = withEnterpriseLayout(ManageReportsPage);

  return (
    <Switch>
      <Route
        exact
        path={ReportingPaths.create}
        component={(): ReactElement => (
          <CreateReportsPageLayout pageTitle="Create Reports" />
        )}
      />
      <Route
        exact
        path={ReportingPaths.manage}
        component={(): ReactElement => (
          <ManageReportsPageLayout pageTitle="Reports | Manage" />
        )}
      />
    </Switch>
  );
};
